module.exports = (__webpack_require__(1))(42);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/getCurrentLocale.js from dll-reference rlink_core
// module id = 571
// module chunks = 0